import { render, staticRenderFns } from "./LatestDevelopmentsBack.vue?vue&type=template&id=7f6b8866&scoped=true"
import script from "./LatestDevelopmentsBack.vue?vue&type=script&lang=js"
export * from "./LatestDevelopmentsBack.vue?vue&type=script&lang=js"
import style0 from "./LatestDevelopmentsBack.vue?vue&type=style&index=0&id=7f6b8866&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b8866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6b8866')) {
      api.createRecord('7f6b8866', component.options)
    } else {
      api.reload('7f6b8866', component.options)
    }
    module.hot.accept("./LatestDevelopmentsBack.vue?vue&type=template&id=7f6b8866&scoped=true", function () {
      api.rerender('7f6b8866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/details/LatestDevelopmentsBack.vue"
export default component.exports